import type { FunctionComponent } from 'react';

import type { SpartacuxProductDiscoveryDomainState } from '@/domains/productDiscovery/productDiscovery.model';
import type { ProcessedRecommendationItem } from '@/domains/productDiscovery/Recommendation/interfaces/msRecommendation';
import type { RecommendationPlaylist } from '@/domains/productDiscovery/Recommendation/interfaces/productRecommendation';
import { ProductRecommendation } from '@/domains/productDiscovery/Recommendation/modules/ProductRecommendation/ProductRecommendation';

import styles from './recommendation.module.scss';

export interface RecommendationProps {
  withProductCardsLight?: boolean;
  placeHolderSelector: (
    state: Partial<SpartacuxProductDiscoveryDomainState>,
  ) => ProcessedRecommendationItem | undefined;
  recommendationSelector: (
    state: SpartacuxProductDiscoveryDomainState,
  ) => RecommendationPlaylist | undefined;
  dataTestId?: string;
  displayDeliveryLabel?: boolean;
  position: number;
  blockClicked?: string;
  addToCart?: boolean;
  displayAddToCartModal?: boolean;
  displayAddToCartCustomSummary?: boolean;
  withSideArrows?: boolean;
  titleLabel?: string;
}

export const Recommendation: FunctionComponent<RecommendationProps> = ({
  withProductCardsLight,
  placeHolderSelector,
  recommendationSelector,
  dataTestId = 'recommendation',
  displayDeliveryLabel,
  position,
  blockClicked,
  addToCart,
  displayAddToCartModal,
  displayAddToCartCustomSummary,
  withSideArrows = false,
  titleLabel,
}) => (
  <div className={styles.container} data-testid={dataTestId}>
    <ProductRecommendation
      titleLabel={titleLabel}
      className={styles.wrapper}
      withProductCardsLight={withProductCardsLight}
      placeHolderSelector={placeHolderSelector}
      recommendationSelector={recommendationSelector}
      displayDeliveryLabel={displayDeliveryLabel}
      playlistLocation="product_page"
      position={position}
      blockClicked={blockClicked}
      addToCart={addToCart}
      displayAddToCartModal={displayAddToCartModal}
      displayAddToCartCustomSummary={displayAddToCartCustomSummary}
      withSideArrows={withSideArrows}
    />
  </div>
);

Recommendation.displayName = 'Recommendation';
